module.exports = "<!-- TODO: make options dynamic data -->\n<label for=\"select-1\">\n    {{$ctrl.label}}\n    <span class=\"required\" ng-if=\"$ctrl.isRequired\">*</span>\n</label>\n<div class=\"select-wrapper\" id=\"select-1\">\n    <select>\n        <option value=\"\" disabled selected hidden>{{$ctrl.placeholder}}</option>\n        <option value=\"2\">Select option 1</option>\n        <option value=\"3\">Select option 3</option>\n        <option value=\"4\">Select option 4</option>\n    </select>\n    <span class=\"arrow\"></span>\n</div><!-- /.select-wrapper -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpSelect/adpSelect.html
// module id = 585
// module chunks = 0